import UndoNewIcon from "../images/UndoNewIcon.svg";
import ZoomOutNewIcon from "../images/Zoom-Out-New-Icon.svg";
import ZoomInNewIcon from "../images/Zoom-In-New-Icon.svg";
import DownArrowIcon from "../images/DownArrowIcon.svg";
// import SaveChangesNewIcon from "../images/SaveChangesNewIcon.svg";
// import RedoNewIcon from "../images/RedoNewIcon.svg";
import CodeNewIcon from "../images/Code-Editor-New-Icon.svg";
import InfoNewIcon from "../images/information--square.svg";
// import InfoNewIcon from "../images/InfoNewIcon.svg";
import PreviewNewIcon from "../images/Preview-New-Icon.svg";
import RatioChangeModal from "./Responsive/RatioChangeModal"
import CloseIcon from "../images/Close-Small.svg";
import SuccessIcon from "../images/Success-Icon.svg";
import ErrorIcon from "../images/Error-Icon.svg";

import CustomTooltip from "./Tooltip/Tooltip";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { PDFPreview, openPdfRsdPreview } from "../services/apis";
import {
  showErrorToast,
  showSuccessToast,
} from "./toastComponent/ToastComponent";
import { useNavigate } from "react-router-dom";

const TopPanelIcons = ({
  editor,
  setCodeEditor,
  scaleCentPercent,
  setScaleCentPercent,
  setZommedHundredPercent,
  inputElement,
  codeEditor,
  cardInfoHandler,
  undoCurrentStatus,
  undoManager,
  redoManager,
  redoCurrentStatus,
  appData,
  selectedItem,
  setSelectedItem,
  setMlrPdfLoader,
  setpdfURL,
  setCodeEditorLoading,
  setSaveLoading,
  setDimensionVariable,
  calculateNormalizedZoom,
  expandLeft
}) => {
  // Store the reference zoom level for 100% based on current dimension
  const [baseNormalizedZoom, setBaseNormalizedZoomState] = useState(null);
  
  const setBaseNormalizedZoom = (zoom) => {
    // console.log('Setting base normalized zoom to:', zoom);
    setBaseNormalizedZoomState(zoom);
  };
  const [showTooltip, setShowTooltip] = useState(false);

  const [deviceList, setDeviceList] = useState([
    /*  { value: "4:3", id: "ratio_4_3" },
    { value: "16:9", id: "ratio_16_9" },
    { value:"59:41",id:"ratio_59_41" } */
    { value: "1024 x 768", id: "dim_1024*768" },
    { value: "2048 x 1536", id: "dim_2048*1536" },
    { value: "2388 x 1668", id: "dim_2388*1668" },
    { value: "2752 x 2064", id: "dim_2752*2064" },
  ]);
  const [openRatioChangeModal, setOpenRatioChangeModal] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [activeButton, setActiveButton] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [items, setItems] = useState(["Details", appData?.deckId?.uploaded_pdf_path ? "" : ""]);
  const [activeCount, setActiveCount] = useState("");

  const navigate = useNavigate();

  const defaultRatio = appData?.deckId?.default_aspect_ratio;
  useEffect(() => {
    if (defaultRatio) {
      const reorderedList = [...deviceList];
      const selectedItemIndex = reorderedList?.findIndex(
        (item) => item.id === defaultRatio
      );
      if (selectedItemIndex !== -1) {
        const [selectedItem] = reorderedList?.splice(selectedItemIndex, 1);
        reorderedList?.unshift(selectedItem);
      }
      setDeviceList(reorderedList);
      setSelectedItem(defaultRatio);

      const handleClickOutside = (e) => {
        if (
          menuRef?.current &&
          !menuRef?.current?.contains(e.target) &&
          buttonRef?.current &&
          !buttonRef?.current?.contains(e.target)
        ) {
          setShowTooltip(false); // Close the menu if click is outside
        }
      };

      document.addEventListener("click", handleClickOutside);

      // Cleanup the event listener when component is unmounted
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [appData?.deckId]);

  const seletedRatio = deviceList?.find((li) => li?.id === selectedItem);

  const showDeviceList = () => {
    setShowTooltip((prevState) => !prevState);
  };
  const [tempList, setTempList] = useState("");
  const selectDimension = (list) => {
    editor.store();
    setTimeout(() => {
      setTempList(list);
      setOpenRatioChangeModal(true);
    }, 0);
   
  };
  const ratioChangeConfirmation = (type, value) => {
    setOpenRatioChangeModal(false);
    if (type === "YES") {
      setSaveLoading(true);
      setDimensionVariable(true)
      localStorage.setItem("SwitchDimen", true);
      setSelectedItem(tempList?.id);
      setShowTooltip(false);
      setScaleCentPercent(100);           
    } else if (type === "No") {
      setShowTooltip(false);
    }
  };

  const setInitialNormalizedZoom = () => {
    if (selectedItem && inputElement?.current && editor?.Canvas && calculateNormalizedZoom) {
      const containerRect = inputElement.current.getBoundingClientRect();
      const normalizedZoom = calculateNormalizedZoom(selectedItem, containerRect, 100, expandLeft);
      setBaseNormalizedZoom(normalizedZoom);
      editor.Canvas.setZoom(normalizedZoom);
    }
  };

  const captureCurrentZoomAsBase = () => {
    if (editor?.Canvas) {
      const currentZoom = editor.Canvas.getZoom();
      // console.log('Capturing current zoom as base:', currentZoom);
      setBaseNormalizedZoom(currentZoom);
    }
  };

  const resetZoom = () => {
    const canvas = editor?.Canvas;
    if (!canvas) return;

    const frameWrapper = document.querySelector(".gjs-cv-canvas__frames");
    const canvasWrapper = document.querySelector(".gjs-cv-canvas");

    // --- Apply 100% layout FIRST ---
    // This is important so centering is respected when zoom is applied
    if (frameWrapper) {
      frameWrapper.style.setProperty(
        "transform-origin",
        "center center",
        "important"
      );
      frameWrapper.style.setProperty(
        "position",
        "unset",
        "important"
      );
    }

    if (canvasWrapper) {
      canvasWrapper.style.setProperty(
        "overflow",
        "hidden",
        "important"
      );
      canvasWrapper.style.setProperty(
        "display",
        "flex",
        "important"
      );
      canvasWrapper.style.setProperty(
        "justify-content",
        "center",
        "important"
      );
      canvasWrapper.style.setProperty(
        "align-items",
        "center",
        "important"
      );
    }

    // --- Restore zoom (same priority as zoomIn/zoomOut) ---
    if (selectedItem && inputElement?.current && calculateNormalizedZoom) {
      const containerRect = inputElement.current.getBoundingClientRect();
      const normalizedZoom = calculateNormalizedZoom(
        selectedItem,
        containerRect,
        100,
        expandLeft
      );
      canvas.setZoom(normalizedZoom);

      // Keep baseline in sync
      if (!baseNormalizedZoom) {
        setBaseNormalizedZoom(normalizedZoom);
      }
    } else if (baseNormalizedZoom) {
      canvas.setZoom(baseNormalizedZoom);
    } else {
      const currentZoom = canvas.getZoom() || 1;
      canvas.setZoom(currentZoom);
      setBaseNormalizedZoom(currentZoom);
    }

    // --- Reset zoom state ---
    setScaleCentPercent(100);
    setZommedHundredPercent(true);
  };


  const editorZoomOut = () => {
    // Capture base zoom if we don't have it and we're currently at 100%
    if (!baseNormalizedZoom && scaleCentPercent === 100 && editor?.Canvas) {
      const currentZoom = editor.Canvas.getZoom();
      // console.log('Capturing zoom on first zoom out:', currentZoom);
      setBaseNormalizedZoom(currentZoom);
    }

    const frameWrapper = document.querySelector(".gjs-cv-canvas__frames");
    const canvasWrapper = document.querySelector(".gjs-cv-canvas");

    if (frameWrapper) {
      if (scaleCentPercent > 110) {
        frameWrapper.style.setProperty("transform-origin", "top left", "important");
        frameWrapper.style.setProperty("position", "absolute", "important");
      } else {
        frameWrapper.style.setProperty("transform-origin", "center center", "important");
        frameWrapper.style.setProperty("position", "unset", "important");
      }
    }

    if (canvasWrapper) {
      if (scaleCentPercent > 110) {
        canvasWrapper.style.setProperty("overflow", "auto", "important");
      } else {
        canvasWrapper.style.setProperty("overflow", "hidden", "important");
        canvasWrapper.style.setProperty("display", "flex", "important");
        canvasWrapper.style.setProperty("justify-content", "center", "important");
        canvasWrapper.style.setProperty("align-items", "center", "important");
      }
    }
    setZommedHundredPercent(false);
    const canvas = editor?.Canvas;
    const zoom = canvas?.getZoom();
    if (scaleCentPercent === 110) {
      setZommedHundredPercent(true);
    }
      
    if (scaleCentPercent > 40) {
      const newScalePercent = scaleCentPercent - 10;
      
      if (newScalePercent === 100 && baseNormalizedZoom) {
        // Special case: returning to 100% should use the stored base zoom
        // console.log('Zoom OUT - Restoring to 100% using base zoom:', baseNormalizedZoom);
        // console.log('Zoom OUT - Current zoom before restore:', canvas?.getZoom());
        canvas?.setZoom(baseNormalizedZoom);
        setScaleCentPercent(100);
        setZommedHundredPercent(true);
      } else if (selectedItem && inputElement?.current && calculateNormalizedZoom) {
        const containerRect = inputElement.current.getBoundingClientRect();
        const normalizedZoom = calculateNormalizedZoom(selectedItem, containerRect, newScalePercent, expandLeft);
        
        canvas?.setZoom(normalizedZoom);
        setScaleCentPercent(newScalePercent);
      } else if (baseNormalizedZoom) {
        // Use stored base zoom as reference for scaling
        const scaleRatio = newScalePercent / 100;
        const newZoom = baseNormalizedZoom * scaleRatio;
        canvas?.setZoom(newZoom);
        setScaleCentPercent(newScalePercent);
      } else {
        const currentZoom = canvas?.getZoom() || 1;
        const newZoom = currentZoom * 0.9;
        canvas?.setZoom(newZoom);
        setScaleCentPercent(newScalePercent);
      }
    }
  };

  const editorZoomIn = () => {
    // Capture base zoom if we don't have it and we're currently at 100%
    if (!baseNormalizedZoom && scaleCentPercent === 100 && editor?.Canvas) {
      const currentZoom = editor.Canvas.getZoom();
      // console.log('Capturing zoom on first zoom in:', currentZoom);
      setBaseNormalizedZoom(currentZoom);
    }

    const frameWrapper = document.querySelector(".gjs-cv-canvas__frames");
    const canvasWrapper = document.querySelector(".gjs-cv-canvas");

    if (frameWrapper) {
      if (scaleCentPercent >= 100) {
        frameWrapper.style.setProperty("transform-origin", "top left", "important");
        frameWrapper.style.setProperty("position", "absolute", "important");
      } else {
        frameWrapper.style.setProperty("transform-origin", "center center", "important");
        frameWrapper.style.setProperty("position", "unset", "important");
      }
    }

    if (canvasWrapper) {
      if (scaleCentPercent >= 100) {
        canvasWrapper.style.setProperty("overflow", "auto", "important");
      } else {
        canvasWrapper.style.setProperty("overflow", "hidden", "important");
        canvasWrapper.style.setProperty("display", "flex", "important");
        canvasWrapper.style.setProperty("justify-content", "center", "important");
        canvasWrapper.style.setProperty("align-items", "center", "important");
      }
    }

    setZommedHundredPercent(false);
    const canvas = editor?.Canvas;
    const zoom = canvas?.getZoom();
    if (scaleCentPercent === 90) {
      setZommedHundredPercent(true);
    }
    if (scaleCentPercent < 200) {
      const newScalePercent = scaleCentPercent + 10;
      
      if (newScalePercent === 100 && baseNormalizedZoom) {
        // Special case: returning to 100% should use the stored base zoom
        // console.log('Zoom IN - Restoring to 100% using base zoom:', baseNormalizedZoom);
        // console.log('Zoom IN - Current zoom before restore:', canvas?.getZoom());
        canvas?.setZoom(baseNormalizedZoom);
        setScaleCentPercent(100);
        setZommedHundredPercent(true);
      } else if (selectedItem && inputElement?.current && calculateNormalizedZoom) {
        const containerRect = inputElement.current.getBoundingClientRect();
        const normalizedZoom = calculateNormalizedZoom(selectedItem, containerRect, newScalePercent, expandLeft);
        
        canvas?.setZoom(normalizedZoom);
        setScaleCentPercent(newScalePercent);
      } else if (baseNormalizedZoom) {
        // Use stored base zoom as reference for scaling
        const scaleRatio = newScalePercent / 100;
        const newZoom = baseNormalizedZoom * scaleRatio;
        canvas?.setZoom(newZoom);
        setScaleCentPercent(newScalePercent);
      } else {
        const currentZoom = canvas?.getZoom() || 1;
        const newZoom = currentZoom * 1.1;
        canvas?.setZoom(newZoom);
        setScaleCentPercent(newScalePercent);
      }
    }
  };

 
  // Reset base zoom when dimension or expansion changes
  useEffect(() => {
    setBaseNormalizedZoom(null);
    if (selectedItem && inputElement?.current && editor?.Canvas && calculateNormalizedZoom) {
      setTimeout(() => {
        setInitialNormalizedZoom();
      }, 100); // Small delay to ensure DOM is ready
    }
  }, [selectedItem, expandLeft, editor]);

  // Capture base zoom after editor is fully loaded
  useEffect(() => {
    if (editor?.Canvas && scaleCentPercent === 100 && !baseNormalizedZoom) {
      // Wait a bit for editor to fully initialize
      setTimeout(() => {
        captureCurrentZoomAsBase();
      }, 200);
    }
  }, [editor, scaleCentPercent, baseNormalizedZoom]);

  useEffect(() => {
    if (!editor) return; 
  
    const handleLoad = () => {
      const frames = document.querySelector(".gjs-cv-canvas__frames");
      if (!frames) {
        console.warn("Frames element not found");
        return;
      }
  
     const observer = new ResizeObserver((entries) => {
       for (const entry of entries) {
         const { width, height } = entry.contentRect;
         setTimeout(() => {
           setInitialNormalizedZoom();
           // Also capture the resulting zoom as base after a short delay
           setTimeout(() => {
             if (scaleCentPercent === 100) {
               captureCurrentZoomAsBase();
             }
           }, 50);
         }, 10);
       }
     });
  
      observer.observe(frames);
  
      editor.on("destroy", () => observer.disconnect());
    };
  
    editor.on("load", handleLoad);
  
    return () => {
      editor.off("load", handleLoad);
    };
  }, [editor]);
  

   
  const handleButtonClick = (item) => {
    if (item === "Export") {
      editor.runCommand("export");
    } else if (item === "Details") {
      cardInfoHandler();
    } else if (item === "Preview RSD") {
      if (appData?.deckId?.uploaded_pdf_path) {
        clicKRsdPreview();
      } else {
        showErrorToast("Please generate RSD first");
      }
    }
  
  setDropdownOpen(false); // Close the dropdown
};
// console.log(redoCurrentStatus);
const toggleDropdown = (isOpen) => {
  setDropdownOpen(isOpen);
};

const generateRSDHandler = () => {
  setMlrPdfLoader(true);
  PDFPreview(appData?.deckId?._id, (response, err, errorCode) => {
    const errorData = err?.response?.data?.err;

    if (
      typeof errorData === "string" &&
      errorData.startsWith("Slide Named")
    ) {
      setMlrPdfLoader(false);
      showErrorToast(errorData);
    } else if (errorData?.message) {
      setMlrPdfLoader(false);
      showErrorToast("Export failed. Please try again.");
    } else if (errorData) {
      console.log(err);
      setMlrPdfLoader(false);
      showErrorToast("Export failed. Please try again.");
    } else {
     // setMlrPdfLoader(false);
      setpdfURL(response.data);
      showSuccessToast("Your link will be emailed shortly");
      navigate("/");
       setMlrPdfLoader(false);
    }
  });
};

const clicKRsdPreview = () => {
  setSaveLoading(true);
  openPdfRsdPreview(appData?.deckId?._id, (response, err, errorCode) => {
    if (err) {
      setSaveLoading(false);
      showErrorToast(err.response.data.error);
    } else {
      setSaveLoading(false);
      window.open(response.data.response.rsdPreviewLink, '_blank', 'noopener,noreferrer');
    }
  });
};
return (
  <div className="editor-wrapper-header-content2 d-flex">
    <ul className="d-flex topPanelEditorIcons">
      {defaultRatio &&
        (appData?.deckId?.type === 1 || (2 && seletedRatio)) && (
          <li className="drop-down-device-menu">
            <div
              ref={buttonRef}
              className="d-flex align-items-center"
              onClick={showDeviceList}
              style={{ cursor: "pointer" }}
            >
              <h3 className="">{seletedRatio?.value}</h3>
              <img
                className={showTooltip ? "expand-device-list" : ""}
                src={DownArrowIcon}
                alt=""
              />
            </div>
            {showTooltip && (
              <ul
                ref={menuRef}
                className="dropdown-device-list"
                style={{ position: "absolute", zIndex: 2 }}
              >
                {deviceList &&
                  deviceList.map((list, index) => (
                    <li
                      onClick={() => selectDimension(list)}
                      className={
                        list?.id === selectedItem ? "selected-ratio" : ""
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {list?.value}{" "}
                      {list?.id === defaultRatio ? "(Default)" : ""}
                    </li>
                  ))}
              </ul>
            )}
          </li>
        )}
      {/* <li
          onClick={() => {
            //editor.runCommand("undo");
            undoManager();
          }}
          // title="Undo"
          className={!redoCurrentStatus ? "urDisabled" : null}
        >
          <CustomTooltip title="Undo" classes="editor-wrapper-undo-popover">
            <img
              alt="undo"
              src={UndoNewIcon}
              width={24}
              height={24}
              style={{ cursor: "pointer" }}
              className="codeEditorIcon"
            />
          </CustomTooltip>
        </li>

        <li
          onClick={() => {
            redoManager();
            // editor.runCommand("redo");
          }}
          // title="Redo"
        >
          <CustomTooltip title="Redo" classes="editor-wrapper-redo-popover">
            <img
              alt="redo"
              src={RedoNewIcon}
              style={{ width: "24px", height: "24px", cursor: "pointer" }}
              className={`codeEditorIcon editor-wrapper-common1 ${
                !undoCurrentStatus ? "urDisabled" : null
              }`}
            />
          </CustomTooltip>
        </li> */}

      <li className="zoom-in-out">
        <div className="editor-wrapper-zoominout">
          <img
            src={ZoomInNewIcon}
            alt="zoom Out"
            className="zoom-in"
            onClick={editorZoomOut}
            width={16}
            height={16}
          />
          {/* <button ></button> */}
          <span 
            className="persent-display" 
            onDoubleClick={resetZoom}
            style={{ cursor: 'pointer' }}
            title="Double-click to reset to 100%"
          >
            {`${scaleCentPercent}%`}
          </span>
          {/* <button  onClick={editorZoomIn}>+</button> */}
          <img
            src={ZoomOutNewIcon}
            alt="zoom In"
            className="zoom-out"
            onClick={editorZoomIn}
            width={16}
            height={16}
          />
        </div>
        {/* <button className="zoomReset" onClick={resetZoom}>
          Reset
        </button> */}
      </li>

      <li className="p-0">
        <CustomTooltip
          title="Gridlines"
          classes="editor-wrapper-gridlines-popover"
        >
          <div id="editor-actions-btns" className="panel__editor-btns"></div>
        </CustomTooltip>
      </li>

      <li
        onClick={() => {
          setCodeEditorLoading(true);
          setCodeEditor(!codeEditor);
        }}
      // title="Code Editor"
      >
        <CustomTooltip
          title="Code Editor"
          classes="editor-wrapper-code-popover"
        >
          <img
            alt="CodeEditorIcon"
            src={CodeNewIcon}
            style={{ width: "24px", height: "18px", cursor: "pointer" }}
            className="codeEditorIcon editor-wrapper-common2"
          />
        </CustomTooltip>
      </li>

      {/* <li className="topiconsDivider"></li> */}

      {/* <li
          onClick={() => {
            cardInfoHandler();
          }}
        >
          <CustomTooltip title="Info" classes="editor-wrapper-info-popover">
            <img
              alt="InfoIconWhite"
              src={InfoNewIcon}
              style={{ height: "24px" }}
              className="infoIconL editor-wrapper-info-icon"
            />
          </CustomTooltip>
        </li> */}

      <li
        className={`flex-fill listItems 
          `}
        onClick={() => {
          editor.runCommand("preview");
        }}
      // title="Preview"
      >
        <CustomTooltip
          title="Preview"
          classes="editor-wrapper-preview-popover"
        >
          <img
            alt="InfoIconWhite"
            src={PreviewNewIcon}
            style={{ width: "18px", height: "18px" }}
            className="infoIconL"
          />
        </CustomTooltip>
      </li>

      {/* <li>
          <button
            className="editor-wrapper-header-publish"
            onClick={() => {
              editor.runCommand("export");
            }}
          >
            EXPORT
          </button>
        </li> */}
      <li>
        <Dropdown
          show={dropdownOpen}
          onToggle={toggleDropdown}
          className="user-action-dropdown-button"
        >
          <Dropdown.Toggle>USER ACTION(S)</Dropdown.Toggle>
          <Dropdown.Menu>
            {items.map((item, index) => (
              <Dropdown.Item
                onClick={() => {
                  handleButtonClick(item);
                }}
              >
                <span>{item}</span>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </li>
      <li>
        <button className="generate-rsd" onClick={generateRSDHandler}>
          GENERATE RSD
        </button>
      </li>
    </ul>
    {openRatioChangeModal && (
      <RatioChangeModal
        openRatioChangeModal={openRatioChangeModal}
        setOpenRatioChangeModal={setOpenRatioChangeModal}
        ratioChangeConfirmation={ratioChangeConfirmation}
      ></RatioChangeModal>
    )}
  </div>
);
};

export default TopPanelIcons;
